import { render, staticRenderFns } from "./wPreview.vue?vue&type=template&id=58c89e06&scoped=true&"
import script from "./wPreview.vue?vue&type=script&lang=js&"
export * from "./wPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c89e06",
  null
  
)

export default component.exports